import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Login from "./Login";
import "../styles/Navbar.css";

export default function YeniNavbar() {
  const navigate = useNavigate();
  const userDropdownRef = useRef(null);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState({ userDropdown: false });
  const [fabOpen, setFabOpen] = useState(false);
  const hoverTimeoutRef = useRef(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const lastScrollY = useRef(window.scrollY || 0);
  const token = localStorage.getItem("token");
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeoutRef.current);
    setDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setDropdownVisible(false);
    }, 2000); // 2 saniye sonra kapat
  };

  useEffect(() => {
    if (token) {
      fetchNavbarPhoto();
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY || 0;

      // Aşağı kayma (biraz toleransla)
      if (currentY > lastScrollY.current + 10 && currentY > 80) {
        setIsNavbarVisible(false);
      }
      // Yukarı kayma
      else if (currentY < lastScrollY.current - 10) {
        setIsNavbarVisible(true);
      }

      // En yukarıdaysa her zaman göster
      if (currentY < 10) {
        setIsNavbarVisible(true);
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fetchNavbarPhoto = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob', // ✅ Burası önemli!
      });

      const imgUrl = URL.createObjectURL(res.data);
      setProfilePhoto(imgUrl);
    } catch (err) {
      console.error("❌ Navbar profil fotoğrafı alınamadı:", err);
    }
  };

  useEffect(() => {
    const currentUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");

    if (!token) {
      // Token hiç yoksa → kullanıcıyı sıfırla
      localStorage.removeItem("user");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
      setUser(null);
      return;
    }

    // Token varsa → doğruluğunu API ile kontrol et
    const checkToken = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/GetUserIdByToken`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 200) {
          // Token geçerliyse → kullanıcıyı göster
          if (currentUser) setUser(JSON.parse(currentUser));
        } else {
          // Token geçersiz → her şeyi temizle
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("userName");
          localStorage.removeItem("userEmail");
          setUser(null);
        }
      } catch (err) {
        console.error("Token kontrol hatası:", err);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("userName");
        localStorage.removeItem("userEmail");
        setUser(null);
      }
    };

    checkToken();
  }, []);


  const toggleDropdown = (menu) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      const savedEmail = localStorage.getItem("loginEmail");
      const savedPassword = localStorage.getItem("loginPassword");

      await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      localStorage.clear();
      if (savedEmail && savedPassword) {
        localStorage.setItem("loginEmail", savedEmail);
        localStorage.setItem("loginPassword", savedPassword);
      }

      setUser(null);
      setShowLogoutConfirm(false);
      navigate("/");
      window.location.reload();
    } catch (err) {
      console.error("Çıkış hatası:", err);
    }
  };

  return (
    <>
      <nav className={`navbar ${isNavbarVisible ? "visible" : "hidden"}`}>
        {/* LOGO */}
        <div className="logo-container" onClick={() => navigate("/")}>
          <img src="/images/fulla.png" className="logo-img" alt="Logo" style={{ cursor: "pointer" }} />
        </div>

        {/* NAV LİNKLER (PC) */}
        <ul className="nav-links">
          <li><Link to="/about">Hakkımızda</Link></li>
          <li>
            <a href="https://www.fullamoda.com/" target="_blank" rel="noopener noreferrer">
              Fulla Moda Online
            </a>
          </li>
          <li><Link to="/joblist">İş İlanları</Link></li>
        </ul>

        {/* GİRİŞ & HAMBURGER */}
        <div className="nav-buttons">
          {user ? (
            <div
              className="user-dropdown"
              ref={userDropdownRef}
              onMouseEnter={() => {
                if (window.innerWidth > 768) {
                  clearTimeout(hoverTimeoutRef.current);
                  setDropdownVisible(true);
                }
              }}
              onMouseLeave={() => {
                if (window.innerWidth > 768) {
                  hoverTimeoutRef.current = setTimeout(() => {
                    setDropdownVisible(false);
                  }, 1000); // 2 saniye sonra kapanır
                }
              }}
            >
              <div className="navbar-user-info">
                {profilePhoto ? (
                  <img src={profilePhoto} alt="Profil" className="navbar-user-photo" />
                ) : (
                  <div className="navbar-user-photo-placeholder">👤</div>
                )}
                <span className="user-name">{user?.adi || "Kullanıcı"}</span>
              </div>


              {dropdownVisible && (
                <div className="modern-user-dropdown">
                  <button onClick={() => navigate("/profil")}> Profil</button>
                  <button onClick={() => navigate("/ozgecmisim")}> Özgeçmişim</button>
                  <button
                    onClick={() => {
                      setShowLogoutConfirm(true);
                      setDropdownVisible(false);
                    }}
                  >
                    Çıkış Yap
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button className="login-btn" onClick={() => setShowLoginPopup(true)}>
              Giriş Yap
            </button>
          )}


          {/* HAMBURGER MENÜ (mobilde görünür) */}
          <div className="hamburger-menu" onClick={toggleMobileMenu}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>

        {/* MOBİL DROPDOWN MENÜ */}
        {mobileMenuOpen && (
          <ul className="mobile-nav-links">
            <li><Link to="/about" onClick={closeMobileMenu}>Hakkımızda</Link></li>
            <li>
              <a href="https://www.fullamoda.com/" target="_blank" rel="noopener noreferrer" onClick={closeMobileMenu}>
                Fulla Moda Online
              </a>
            </li>
            <li><Link to="/joblist" onClick={closeMobileMenu}>İş İlanları</Link></li>

            {user && (
              <>
                <li><Link to="/profil" onClick={closeMobileMenu}>Profil</Link></li>
                <li><Link to="/ozgecmisim" onClick={closeMobileMenu}>Özgeçmişim</Link></li>
                <li>
                  <button onClick={() => { setShowLogoutConfirm(true); closeMobileMenu(); }}>
                    Çıkış Yap
                  </button>
                </li>
              </>
            )}
          </ul>
        )}
      </nav>

      {/* GİRİŞ POPUP */}
      {showLoginPopup && (
        <div className="modal-overlay" onClick={() => setShowLoginPopup(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowLoginPopup(false)}>✖</button>
            <Login onClose={() => setShowLoginPopup(false)} />
          </div>
        </div>
      )}

      {/* ÇIKIŞ ONAY */}
      {showLogoutConfirm && (
        <div className="modal-overlay" onClick={() => setShowLogoutConfirm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Çıkış yapmak istiyor musunuz?</h2>
            <button onClick={handleLogout} className="login-button">Evet, Çıkış Yap</button>
            <button
              onClick={() => setShowLogoutConfirm(false)}
              className="login-button"
              style={{ backgroundColor: "#ccc", color: "black" }}
            >
              Vazgeç
            </button>
          </div>
        </div>
      )}

    </>
  );

}